module.exports = __webpack_public_path__ + "static/payment-page-preview-6224e318e3f16100c4f1afa7fa3cd5b1.png";